import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    patientHistory: [],
    patientDetails: {},
    patientNotes: {}
}

const consultationSlice = createSlice({
    name: "consultation",
    initialState,
    reducers: {
        setPatientHistory: (state, action) => {
            state.patientHistory = [...action.payload];
        },
        setPatientDetails: (state, action) => {
            state.patientDetails = { ...action.payload };
        },
        setPatientNotes: (state, action) => {
            state.patientNotes = { ...action.payload };
        },
        resetConsultation: (state) => {
            state.patientHistory = [];
            state.patientDetails = {};
            state.patientNotes = {};
        },
    }
});

export const { setPatientHistory, setPatientDetails, setPatientNotes, resetConsultation } = consultationSlice.actions;
export default consultationSlice.reducer;